export const routerPaths = {
  home: "/",
  section4: "/section4",
  businessInfo: "/business-info",
  vehiclesInfo: "/vehicles-info",
  completion: "/completion",
  fleetAccountInfo: "/fleet-account-info",
  enrollVehicles: "/enroll-vehicles",
  downloadMembershipCard: "/download-membership-card",
};

export const STEP_ID = "stepId";

export const routeValues = {
  1: routerPaths.fleetAccountInfo,
  2: routerPaths.businessInfo,
  3: routerPaths.vehiclesInfo,
  4: routerPaths.completion,
};
